import { GET_MALL_CART } from '../../../axios/appiendPoints';
import { axiosInstanceNext } from '../../../axios/axios';
import { generateRandomString } from '../../../functions/generateRandomString';
import { FCAction } from '../../../redux/FoodCourt/action';
import { toastError } from '../../../toast';
import { getOrderType } from '../../../webStorage/manageOrderType';
import { removeSessionItem, setSessionItem } from '../../../webStorage/sessionStorage';
export const addToCartHttp = async ({
  addon_ids = '',
  addon,
  mall,
  is_new_variation,
  item_id,
  new_variation = [],
  quantity,
  restaurant_id,
  variation_ids,
  setCookie,
  token,
  table_id,
  user_id,
  cart_item_id,
}) => {
  token = token || generateRandomString(20);
  const orderType = getOrderType();

  setCookie && (await setCookie('fcCartToken', token, { path: '/' }));
  const data = {
    addon_ids,
    addon,
    foodcourt: mall,
    is_new_variation,
    item_id,
    new_variation,
    order_type: Number(orderType),
    quantity: Number(quantity),
    restaurant_id,
    cart_item_id,
    table_id,
    token: token,
    variation_ids: '',
    user_id,
  };

  try {
    const response = await axiosInstanceNext.patch(GET_MALL_CART, data);
    return {
      token: response.data?.data?.status == 1 ? token : null,
      status: response?.data?.data?.status,
    };
  } catch (error) {
    return { token: null };
  }
};
export const getMallCart = ({
  mall,
  table_id,
  dispatch,
  token,
  user_id,
  lat,
  lng,
  address,
  setFoodCourtDeliveryStatus,
  setFoodCourtDeliveryMsg,
  setFoodCourtAddress,
}) => {
  const data = {
    foodcourt: mall,
    order_type: Number(getOrderType(true)),
    table_id,
    token,
    user_id,
    customer_address: address,
    customer_location: [lat, lng],
  };

  mall &&
    token &&
    axiosInstanceNext
      .post(GET_MALL_CART, data)
      .then((response) => {
        dispatch(FCAction(response.data?.data));
        setFoodCourtDeliveryMsg && setFoodCourtDeliveryMsg(response?.data?.data?.delivery?.message);
        setFoodCourtAddress &&
          setFoodCourtAddress(response?.data?.data?.delivery?.customer_address);
        setFoodCourtDeliveryStatus &&
          setFoodCourtDeliveryStatus(response?.data?.data?.delivery?.status);
        if (response?.data?.data?.delivery.status != '1' && address) {
          toastError(response?.data?.data?.delivery?.message);
          setSessionItem('isDelivery', response?.data?.data?.delivery?.message);
        } else {
          removeSessionItem('isDelivery');
        }
      })
      .catch((err) => {
        console.error(err.message);
      });
};
